import { store } from "index";

export default function getKeysByExchange(selectedExchange) {
    const keysByExchange = store.getState().keys.data
    const selectedExchangeData = keysByExchange.find(exchange => exchange.exchange === selectedExchange)
    return selectedExchangeData
}

